import React from 'react';
import { getOpsGetProviderForPatient } from 'api/operation';
import { TOpsProvider } from 'types/common';

const useOpsGetProviderForPatient = (klarityUserId?: number): [TOpsProvider[], boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TOpsProvider[]>();
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getOpsGetProviderForPatient(klarityUserId!);
            if (!result.error) {
                const data = result?.data?.data || [];
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        console.log({
            klarityUserId,
        });
        if (klarityUserId) {
            fetchData();
        }
    }, [klarityUserId]);

    return [items, loading, fetchData];
};

export default useOpsGetProviderForPatient;
